// src/hooks/useAnalytics.js
import { logEvent, setUserId, setUserProperties } from "firebase/analytics";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "../firebase";

const AnalyticsWrapper = () => {
  const location = useLocation();

  useEffect(() => {
    if (analytics && location?.pathname) {
      const user = JSON.parse(localStorage.getItem("user"));
      logEvent(analytics, "cb_portal_page_view", {
        page_path: location.pathname,
        user_id: user?.user_id || "Not Present",
        username: user?.username || "Not Present",
        full_name: user?.full_name || "Not Present",
        email: user?.email || "not_provided",
        role_name: user?.role_name || "Not Present",
      });
      // console.log("📊 Logged Page View:", location.pathname);
    }

      if (analytics) {
      const user = JSON.parse(localStorage.getItem("user"));

      if (user) {
        // ✅ Set user ID
        setUserId(analytics, user?.user_id);

        // ✅ Optional: Set custom user properties
        setUserProperties(analytics, {
        user_id: user?.user_id || "Not Present",
        username: user?.username || "Not Present",
        full_name: user?.full_name || "Not Present",
        email: user?.email || "not_provided",
        role_name: user?.role_name || "Not Present",
        });

        // console.log("👤 User logged in Analytics:", user?.user_id);
      }
    }
  }, [location]);

  return null;
};

export default AnalyticsWrapper;
